(function () {
  var MAX_HEIGHT = 320;

  function initReadMore(body, btn, fade) {
    if (!body || !btn || body.dataset.bnexoReady) {
      return;
    }

    if (body.scrollHeight <= MAX_HEIGHT + 40) {
      return;
    }

    body.dataset.bnexoReady = '1';
    body.classList.add('is-collapsed');
    btn.hidden = false;
    if (fade) {
      fade.hidden = false;
    }

    btn.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-expanded');
      body.classList.toggle('is-collapsed', !expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.querySelector('[data-label-more]').hidden = expanded;
      btn.querySelector('[data-label-less]').hidden = !expanded;
      if (fade) {
        fade.hidden = expanded;
      }
    });
  }

  function scan(scope) {
    (scope || document).querySelectorAll('[data-bnexo-read-more]').forEach(function (body) {
      var root = body.closest('.bnexo-pdp-description');
      if (!root) {
        return;
      }
      initReadMore(body, root.querySelector('[data-bnexo-read-more-btn]'), root.querySelector('[data-bnexo-read-more-fade]'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(document); });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
